import { ArrowPathIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useCanRequestReview } from "@components/ReportReview/hooks/useCanManageReview";
import { useReviewRequest } from "@components/ReportReview/hooks/useReviewRequest";
import { Reviewer } from "@components/ReportReview/reviewers";

export const ReRequestMenuItem: React.FC<{ reviewer: Reviewer }> = ({ reviewer }) => {
  const { request } = useReviewRequest();
  const canRequestReview = useCanRequestReview();

  return (
    <DropdownMenuItem
      disabled={!canRequestReview || reviewer.status === ReportReviewerStatus.Requested}
      onClick={() => reviewer.reviewer && request([{ userId: reviewer.reviewer.id, type: reviewer.type }])}
    >
      <ArrowPathIcon />
      Re-request Review
    </DropdownMenuItem>
  );
};
